import React from "react";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import { InputLabel, TextField, FormControl, Checkbox } from "@mui/material";
import Autocomplete, { autocompleteClasses } from "@mui/material/Autocomplete";
import { VariableSizeList } from "react-window";
import useMediaQuery from "@mui/material/useMediaQuery";
import ListSubheader from "@mui/material/ListSubheader";
import { useTheme } from "@mui/styles";
import { Typography } from "@mui/material";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';
import { Box, Chip } from "@mui/material";

const LISTBOX_PADDING = 8; // px

const toggleItemActive = ({ doSomething, value }) => {
  //console.log(doSomething);
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function renderRow(props) {
  const { data, index, style } = props;
  const dataSet = data[index];
  const inlineStyle = {
    ...style,
    top: style.top + LISTBOX_PADDING,
  };
  //console.error('dataSet');
  //console.error(dataSet);
  if (dataSet.hasOwnProperty('group')) {
    return (
      <ListSubheader key={dataSet.key} component="div" style={inlineStyle}>
        {dataSet.group}
      </ListSubheader>
    );
  }

  return (
    <Typography component="li" {...dataSet[0]} style={inlineStyle}>
      {dataSet[1].parentname ? dataSet[1].parentname : dataSet[1].name}
    </Typography>
  );
}

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function useResetCache(data) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);
  return ref;
}

// Adapter for react-window
const ListboxComponent = React.forwardRef(function ListboxComponent(props, ref) {
  const { children, ...other } = props;
  const itemData = [];
  children.forEach((item) => {
    itemData.push(item);
    itemData.push(...(item.children || []));
  });

  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'), {
    noSsr: true,
  });

  const itemCount = itemData.length;
  const itemSize = smUp ? 36 : 48;

  const getChildSize = (child) => {
    if (child.hasOwnProperty('group')) {
      return 48;
    }

    return itemSize;
  };

  const getHeight = () => {
    if (itemCount > 8) {
      return 8 * itemSize;
    }
    return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
  };

  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          itemData={itemData}
          height={getHeight() + 2 * LISTBOX_PADDING}
          width="100%"
          ref={gridRef}
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={(index) => getChildSize(itemData[index])}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

ListboxComponent.propTypes = {
  children: PropTypes.node,
};

function random(length) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';

  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }

  return result;
}

const StyledPopper = styled(Popper)({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: 'border-box',
    '& ul': {
      padding: 0,
      margin: 0,
    },
  },
});

const OPTIONS = Array.from(new Array(10000))
  .map(() => random(10 + Math.ceil(Math.random() * 20)))
  .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()));



const renderGroup = params => [
  <ListSubheader key={params.key} component="div">
    {params.key}
  </ListSubheader>,
  params.children,
];

const useStyles = makeStyles((theme) => ({
  listbox: {
    "& ul": {
      padding: 0,
      margin: 0,
    },
  },
}));

export default function SimpleAutoCompleteMultiple(props) {
  const {
    label,
    options,
    optionsText,
    stateName,
    changeSelect,
    selected,
    required,
    disabled = false,
  } = props;

  const defaultvalue = [];
  const classes = useStyles();

  const [opt, setOption] = React.useState(selected ? selected : defaultvalue);

  React.useEffect(() => {
    setOption(selected ? selected : defaultvalue);
  }, [selected]);

  const handleChange = (event, value) => {
    if (value == null) {
      value = [];
    }

    setOption(value);
    changeSelect(stateName, value);
  };
  function getIds() {
    const idList = options.map((item) => {
      return item.id;
    });
    return idList;
  }
  function getNames() {
    const idList = options.map((item) => {
      return item.tipping
        ? item.tipping
        : item.parentname
          ? item.parentname
          : item.name;
    });
    return idList;
  }
  function Result() {
    return (

      <Autocomplete
        disabled={disabled}
        multiple
        limitTags={2}
        disableCloseOnSelect
        id="combo-box"
        PopperComponent={StyledPopper}
        filterSelectedOptions={true}
        options={options}
        disableListWrap
        classes={classes}
        value={opt}
        //defaultValue={opt}
        ListboxComponent={ListboxComponent}
        getOptionLabel={(option) =>
          option.parentname ? option.parentname : option.name ? option.name : ""
        }
        getOptionDisabled={null}
        onChange={handleChange}

        //renderOption={(option) => <Typography component={'span'} variant={'body2'} noWrap>{option}</Typography>}
        renderOption={(props, option) => [props, option]}

        style={{
          fullWidth: true,
          display: "table",
          tableLayout: "fixed",
          width: "100%",
          maxWidth: "100%",
        }}
        //renderOption={(option, { selected }) => (
        //  <React.Fragment>
        //    <Checkbox
        //      icon={icon}
        //      checkedIcon={checkedIcon}
        //      style={{ marginRight: 8 }}
        //      checked={selected}
        //    />
        //    {option}
        //  </React.Fragment>
        //)}
        renderTags={(value, getTagProps, ownerState,) => {
          if (!ownerState.focused) {
            const tagsToDisplay = value.slice(0, 2);
            const numRemaining = value.length - 2;

            return (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {tagsToDisplay.map((option, index) => (
                  <Chip
                    // variant="outlined"
                    label={option.parentname || option.name || ""}
                    {...getTagProps({ index })}

                  />
                ))}
                {numRemaining > 0 && (
                  <Typography sx={{ alignSelf: 'center', mx: 0.5 }}>
                    +{numRemaining}
                  </Typography>
                )}
              </Box>
            );
          }
          return <Box
            sx={{
              maxHeight: '200px',
              overflow: 'auto',
              display: 'flex',
              flexWrap: 'wrap',
              gap: 0.5,
            }}
          >
            {value.map((option, index) => (
              <Chip
                // variant="outlined"
                label={option.parentname || option.name || ""}
                {...getTagProps({ index })}

              />
            ))}
          </Box>
        }}
        renderInput={(params) => {
          const isRequired = required != null ? required == false ? false : true : false;
          const isEmptyOrInvalid = !opt || !Array.isArray(opt) || opt.length === 0 || opt.every(item => item == null);
          return (
            <TextField 
              {...params} 
              label={label} 
              variant="outlined" 
              placeholder={label} 
              fullWidth 
              required={isRequired}
              inputProps={{
                ...params.inputProps,
                required: isRequired && isEmptyOrInvalid
              }}
            />
          );
        }}
      />
    );
  }
  return <Result />
  //return <div><Result /> <ResultTemp/></div>
}

SimpleAutoCompleteMultiple.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  stateName: PropTypes.string,
  changeSelect: PropTypes.func,
  selected: PropTypes.array,
};